import { useEffect } from "react";

const useLinkClickTracking = () => {
  useEffect(() => {
    const handleClick = (e) => {
      const link = e.target.closest("a");
      if (!link) return;

      const href = link.getAttribute("href");
      const isExternal = /^https?:\/\//.test(href) && !href.includes(window.location.hostname);

      window.trackGoogleAnalyticsEvent(
        isExternal ? "outbound_link_click" : "internal_link_click",
        {
          page_path: window.location.pathname,
          link_url: href,
          link_text: link.textContent || "N/A",
        }
      );
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
};

export default useLinkClickTracking;
